export default "__VITE_ASSET__eXfI$pRK__"